export const ACTIVITY_TYPES = [
    'TASK_CREATED',
    'TASK_UPDATED',
    'TASK_ASSIGNED',
    'TASK_UNASSIGNED',
    'STATUS_CHANGED',
    'PRIORITY_CHANGED',
    'DEADLINE_CHANGED',
    'COMMENT_ADDED',
    'COMMENT_EDITED',
    'COMMENT_DELETED',
    'ATTACHMENT_ADDED',
    'ATTACHMENT_REMOVED',
    'REVIEW_SUBMITTED',
    'REVIEW_APPROVED',
    'REVIEW_CHANGES_REQUESTED',
    'TASK_DELETED',
    'TASK_RESTORED',
];
/* ---------------------------------------------------------------------------
 * Notifications
 * ------------------------------------------------------------------------- */
export const NOTIFICATION_EVENTS = [
    'TASK_ASSIGNED',
    'TASK_SUBMITTED_FOR_REVIEW',
    'TASK_CHANGES_REQUESTED',
    'TASK_APPROVED',
    'TASK_COMMENT_MENTION',
    'TASK_DEADLINE_APPROACHING',
    /**
     * Ticket notifications are deliberately few: nothing fires on creation
     * (visibility already covers that — see the Leadership Request brief), and
     * nothing fires on every mirrored task-progress update. Only the moments
     * that change who needs to act, or that resolve the request.
     */
    'TICKET_ASSIGNED',
    'TICKET_COMPLETED',
    'TICKET_DENIED',
];
export const NOTIFICATION_CHANNELS = ['DISCORD_DM', 'DISCORD_CHANNEL'];
export const NOTIFICATION_STATUSES = ['PENDING', 'SENT', 'FAILED', 'SKIPPED', 'DEAD'];
/* ---------------------------------------------------------------------------
 * Audit
 * ------------------------------------------------------------------------- */
export const AUDIT_ACTIONS = [
    'AUTH_LOGIN',
    'AUTH_LOGIN_DENIED',
    'AUTH_LOGOUT',
    'AUTH_SESSION_REVOKED',
    'PERMISSION_DENIED',
    'TASK_CREATED',
    'TASK_UPDATED',
    'TASK_ASSIGNED',
    'TASK_STATUS_CHANGED',
    'TASK_SUBMITTED_FOR_REVIEW',
    'TASK_APPROVED',
    'TASK_CHANGES_REQUESTED',
    'TASK_CANCELLED',
    'TASK_ARCHIVED',
    'TASK_DELETED',
    'TASK_RESTORED',
    'COMMENT_CREATED',
    'COMMENT_EDITED',
    'COMMENT_DELETED',
    'ATTACHMENT_UPLOADED',
    'ATTACHMENT_DELETED',
    'USER_ROLE_CHANGED',
    'USER_DEACTIVATED',
    'USER_REACTIVATED',
    'USER_DISPLAY_NAME_CHANGED',
    'SETTING_CHANGED',
    'ROLE_MAPPING_CHANGED',
    'REFERENCE_DATA_CHANGED',
    'NOTIFICATION_FAILED',
    'DISCORD_API_ERROR',
    'TICKET_CREATED',
    'TICKET_ASSIGNED',
    'TICKET_TASK_LINKED',
    'TICKET_COMPLETED',
    'TICKET_DENIED',
];
//# sourceMappingURL=domain.js.map